import React, { Component } from "react";
import Header from "./header";
import Footer from "./footer";
import { withTranslation } from "react-i18next";
import { getPublicUrl } from "../utils/utils";
import store from "store";

class Completed extends Component {
  constructor(props) {
    super(props);

    try {
      //this.id = props.location.state.orderId;
      this.id = props.match?.params?.orderId;
      this.isProductTypeAudio = false;
      this.product = store.get("product");
      if (this.product && this.product.productType === "audio") {
        this.isProductTypeAudio = true;
      }
      store.remove("product");
      store.remove("editorState");
      store.remove("editorStateDate");
      store.remove("audioEditorState");
      store.remove("audioEditorStateDate");
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  }

  renderSendAudioButttons() {
    if (!this.isProductTypeAudio) {
      return null;
    }

    return (
      <div className="alert alert-success g-bg-white  text-left" role="alert">
        <p className="g-mb-10">
          <i className="fa fa-info-circle"></i> Тим часом ви можете відправити запис
          вашого голосу у вигляді голосового повідомлення у Viber чи Telegram
        </p>
        <div className="text-center">
          <a
            href="viber://chat?number=380665444363"
            className="btn u-btn-outline-primary btn-md rounded-0"
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/img/viber.svg"}
              style={{ height: "12px" }}
              className="g-mr-4"
            />
            {/* <i className="fa fa-cog g-mr-2"></i> */}
            Viber
          </a>
          <a
            href="https://t.me/mimimapsua"
            className="btn u-btn-outline-primary btn-md rounded-0"
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/img/telegram.svg"}
              style={{ height: "12px" }}
              className="g-mr-4"
            />
            {/* <i className="fa fa-cog g-mr-2"></i> */}
            Telegram
          </a>
        </div>
      </div>
    );
  }

  render() {
    const { t, i18n } = this.props;
    const homeUrl =
      getPublicUrl(i18n) + (this.isProductTypeAudio ? "/audio" : "");
    return (
      <div className="d-flex flex-column">
        <Header></Header>
        <div className="container g-py-100">
          <div className="u-shadow-v19 g-max-width-645 g-brd-around g-brd-gray-light-v4 g-bg-gray-light-v5 rounded mx-auto g-pa-30 g-pa-50--md">
            <div className="text-center">
              <span className="u-icon-v3 u-icon-size--lg g-color-white g-bg-primary rounded-circle g-pa-10 mb-3">
                <svg
                  width="30"
                  height="30"
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 497.5 497.5"
                  enableBackground="new 0 0 497.5 497.5"
                  space="preserve"
                >
                  <g>
                    <path
                      d="M487.75,78.125c-13-13-33-13-46,0l-272,272l-114-113c-13-13-33-13-46,0s-13,33,0,46l137,136
                  c6,6,15,10,23,10s17-4,23-10l295-294C500.75,112.125,500.75,91.125,487.75,78.125z"
                      fill="#fff"
                    />
                  </g>
                </svg>
              </span>
            </div>
            <div className="">
              <h2 className="text-center">{t("Ваше замовлення прийняте!")}</h2>
              <p className="text-center">
                {t("Номер замовлення:")} {this.id}
              </p>
              <p>
                {t(
                  "Ми зв'яжемося з Вами найближчим часом, за вказаним номером телефону, для підтвердження деталей замовлення."
                )}
              </p>
              {this.renderSendAudioButttons()}
              <p>
                {t(
                  "Якщо у вас є питання, зверніться до менеджера за телефоном +380665444363, або за email: info@mimimaps.com.ua"
                )}
              </p>
            </div>
            <div className="text-center">
              <a
                href={homeUrl}
                className="btn u-btn-primary g-font-size-12 text-uppercase g-py-12 g-px-25"
              >
                <i className="fa fa-shopping-cart"></i>{" "}
                {t("Повернутися на головну")}
              </a>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <Footer></Footer>
      </div>
    );
  }
}
export default withTranslation()(Completed);
